import AppLayout from '@/layout/AppLayout.vue';
import { AuthService } from '@/service/AuthService';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'Dashboard',
                    component: () => import('@/views/Dashboard.vue'),
                    meta: { title: 'Dashboard - Solution Experts' }
                },
                {
                    path: '/definition/user',
                    name: 'User',
                    component: () => import('@/views/definition/User.vue'),
                    meta: { title: 'User - Solution Experts' }
                },
                {
                    path: '/definition/accounting-period',
                    name: 'Accounting Period',
                    component: () => import('@/views/definition/AccountingPeriod.vue'),
                    meta: { title: 'Accounting Period - Solution Experts' }
                },
                {
                    path: '/definition/branch',
                    name: 'Branch',
                    component: () => import('@/views/definition/Branch.vue'),
                    meta: { title: 'Branch - Solution Experts' }
                },
                {
                    path: '/definition/warehouse',
                    name: 'Warehouse',
                    component: () => import('@/views/definition/Warehouse.vue'),
                    meta: { title: 'Warehouse - Solution Experts' }
                },
                {
                    path: '/definition/account-group-mapping',
                    name: 'Account Group Mapping',
                    component: () => import('@/views/definition/AccountGroupMapping.vue'),
                    meta: { title: 'Account Group Mapping - Solution Experts' }
                },
                {
                    path: '/definition/general-account-mapping',
                    name: 'General Account & Voucher Mapping',
                    component: () => import('@/views/definition/GeneralAccountMapping.vue'),
                    meta: { title: 'General Account & Voucher Mapping - Solution Experts' }
                },
                {
                    path: '/definition/province',
                    name: 'Province',
                    component: () => import('@/views/definition/Province.vue'),
                    meta: { title: 'Province - Solution Experts' }
                },
                {
                    path: '/definition/city',
                    name: 'City',
                    component: () => import('@/views/definition/City.vue'),
                    meta: { title: 'City - Solution Experts' }
                },
                {
                    path: '/definition/employee-designation',
                    name: 'Employee Designation',
                    component: () => import('@/views/definition/EmployeeDesignation.vue'),
                    meta: { title: 'Employee Designation - Solution Experts' }
                },
                {
                    path: '/definition/employee',
                    name: 'Employee Profile',
                    component: () => import('@/views/definition/Employee.vue'),
                    meta: { title: 'Employee Profile - Solution Experts' }
                },
                {
                    path: '/definition/party-group',
                    name: 'Party Group',
                    component: () => import('@/views/definition/PartyGroup.vue'),
                    meta: { title: 'Party Group - Solution Experts' }
                },
                {
                    path: '/definition/party-grade',
                    name: 'Party Grade',
                    component: () => import('@/views/definition/PartyGrade.vue'),
                    meta: { title: 'Party Grade - Solution Experts' }
                },
                {
                    path: '/definition/party',
                    name: 'Party Profile',
                    component: () => import('@/views/definition/Party.vue'),
                    meta: { title: 'Party Profile - Solution Experts' }
                },
                {
                    path: '/definition/secondary-party',
                    name: 'Secondary Party Profile (Delivery)',
                    component: () => import('@/views/definition/SecondaryParty.vue'),
                    meta: { title: 'Secondary Party Profile (Delivery) - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-type',
                    name: 'Raw Product Sub Type',
                    component: () => import('@/views/definition/RawProductType.vue'),
                    meta: { title: 'Raw Product Sub Type - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-row-rack',
                    name: 'Raw Warehouse Row & Rack Layout',
                    component: () => import('@/views/definition/RawProductRowRack.vue'),
                    meta: { title: 'Raw Warehouse Row & Rack Layout - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-allocation',
                    name: 'Raw Product Allocation',
                    component: () => import('@/views/definition/RawProductAllocation.vue'),
                    meta: { title: 'Raw Product Allocation - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-category',
                    name: 'Raw Product Category',
                    component: () => import('@/views/definition/RawProductCategory.vue'),
                    meta: { title: 'Raw Product Category - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-group',
                    name: 'Raw Product Group',
                    component: () => import('@/views/definition/RawProductGroup.vue'),
                    meta: { title: 'Raw Product Group - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-sub-group',
                    name: 'Raw Product Sub Group',
                    component: () => import('@/views/definition/RawProductSubGroup.vue'),
                    meta: { title: 'Raw Product Sub Group - Solution Experts' }
                },
                {
                    path: '/definition/raw-product',
                    name: 'Raw Product Profile',
                    component: () => import('@/views/definition/RawProduct.vue'),
                    meta: { title: 'Raw Product - Solution Experts' }
                },
                {
                    path: '/definition/product-unit',
                    name: 'Product Unit',
                    component: () => import('@/views/definition/ProductUnit.vue'),
                    meta: { title: 'Product Unit - Solution Experts' }
                },
                {
                    path: '/definition/product-group',
                    name: 'Finished Product Group',
                    component: () => import('@/views/definition/ProductGroup.vue'),
                    meta: { title: 'Finished Product Group - Solution Experts' }
                },
                {
                    path: '/definition/product-sub-group',
                    name: 'Finished Product Sub Group',
                    component: () => import('@/views/definition/ProductSubGroup.vue'),
                    meta: { title: 'Finished Product Sub Group - Solution Experts' }
                },
                {
                    path: '/definition/product-brand',
                    name: 'Finished Product Brand',
                    component: () => import('@/views/definition/ProductBrand.vue'),
                    meta: { title: 'Finished Product Brand - Solution Experts' }
                },
                {
                    path: '/definition/product-variant',
                    name: 'Finished Product Quality Control Variant',
                    component: () => import('@/views/definition/ProductVariant.vue'),
                    meta: { title: 'Finished Product Quality Control Variant - Solution Experts' }
                },
                {
                    path: '/definition/product-packaging-variant',
                    name: 'Finished Product Packaging Variant',
                    component: () => import('@/views/definition/ProductPackagingVariant.vue'),
                    meta: { title: 'Finished Product Packaging Variant - Solution Experts' }
                },
                {
                    path: '/definition/product-packing-quantity',
                    name: 'Finished Product Packing Quantity',
                    component: () => import('@/views/definition/ProductPackingQuantity.vue'),
                    meta: { title: 'Finished Product Packing Quantity - Solution Experts' }
                },
                {
                    path: '/definition/product-tier',
                    name: 'Finished Product Tier',
                    component: () => import('@/views/definition/ProductTier.vue'),
                    meta: { title: 'Finished Product Tier - Solution Experts' }
                },
                {
                    path: '/definition/product-size',
                    name: 'Finished Product Size',
                    component: () => import('@/views/definition/ProductSize.vue'),
                    meta: { title: 'Finished Product Size - Solution Experts' }
                },
                {
                    path: '/definition/product-grade',
                    name: 'Finished Product Grade',
                    component: () => import('@/views/definition/ProductGrade.vue'),
                    meta: { title: 'Finished Product Grade - Solution Experts' }
                },
                {
                    path: '/definition/product',
                    name: 'Finished Product Profile',
                    component: () => import('@/views/definition/Product.vue'),
                    meta: { title: 'Finished Product Profile - Solution Experts' }
                },
                {
                    path: '/definition/permissions',
                    name: 'Permissions',
                    component: () => import('@/views/definition/Permissions.vue'),
                    meta: { title: 'Permissions - Solution Experts' }
                },
                {
                    path: '/definition/chart-of-acccount',
                    name: 'Chart Of Acccount',
                    component: () => import('@/views/definition/ChartOfAccount.vue'),
                    meta: { title: 'Chart Of Acccount - Solution Experts' }
                },
                {
                    path: '/definition/geographical-hierarchy',
                    name: 'Geographical Hierarchy',
                    component: () => import('@/views/definition/GeographicalHierarchy.vue'),
                    meta: { title: 'Geographical Hierarchy - Solution Experts' }
                },
                {
                    path: '/definition/sales-designation-hierarchy',
                    name: 'Sales Designation Hierarchy',
                    component: () => import('@/views/definition/SalesDesignationHierarchy.vue'),
                    meta: { title: 'Sales Designation Hierarchy - Solution Experts' }
                },
                {
                    path: '/definition/letter-of-credit',
                    name: 'Letter Of Credit Profile',
                    component: () => import('@/views/definition/LetterOfCredit.vue'),
                    meta: { title: 'Letter Of Credit Profile - Solution Experts' }
                },
                {
                    path: '/financial/opening-journal',
                    name: 'Opening Journal Voucher',
                    component: () => import('@/views/financial/OpeningJournal.vue'),
                    meta: { title: 'Opening Journal Voucher - Solution Experts' }
                },
                {
                    path: '/financial/journal',
                    name: 'Journal Voucher',
                    component: () => import('@/views/financial/Journal.vue'),
                    meta: { title: 'Journal Voucher - Solution Experts' }
                },
                {
                    path: '/financial/cash-receipt',
                    name: 'Cash Receipt',
                    component: () => import('@/views/financial/CashReceipt.vue'),
                    meta: { title: 'Cash Receipt - Solution Experts' }
                },
                {
                    path: '/financial/cash-payment',
                    name: 'Cash Payment',
                    component: () => import('@/views/financial/CashPayment.vue'),
                    meta: { title: 'Cash Payment - Solution Experts' }
                },
                {
                    path: '/financial/bank-receipt',
                    name: 'Bank Receipt',
                    component: () => import('@/views/financial/BankReceipt.vue'),
                    meta: { title: 'Bank Receipt - Solution Experts' }
                },
                {
                    path: '/financial/bank-payment',
                    name: 'Bank Payment',
                    component: () => import('@/views/financial/BankPayment.vue'),
                    meta: { title: 'Bank Payment - Solution Experts' }
                },
                {
                    path: '/financial/journal-factory',
                    name: 'Journal Voucher Factory',
                    component: () => import('@/views/financial/JournalFactory.vue'),
                    meta: { title: 'Journal Voucher Factory - Solution Experts' }
                },
                {
                    path: '/financial/cash-receipt-factory',
                    name: 'Cash Receipt Factory',
                    component: () => import('@/views/financial/CashReceiptFactory.vue'),
                    meta: { title: 'Cash Receipt Factory - Solution Experts' }
                },
                {
                    path: '/financial/cash-payment-factory',
                    name: 'Cash Payment Factory',
                    component: () => import('@/views/financial/CashPaymentFactory.vue'),
                    meta: { title: 'Cash Payment Factory - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-invoice',
                    name: 'Purchase Invoice',
                    component: () => import('@/views/purchase/PurchaseInvoice.vue'),
                    meta: { title: 'Purchase Invoice - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-return-invoice',
                    name: 'Purchase Return (Debit Note)',
                    component: () => import('@/views/purchase/PurchaseReturnInvoice.vue'),
                    meta: { title: 'Purchase Return (Debit Note) - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-bill-of-materials',
                    name: 'Raw Product Bill Of Materials',
                    component: () => import('@/views/inventory/BillOfMaterials.vue'),
                    meta: { title: 'Raw Product Bill Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-production',
                    name: 'Raw Product Production',
                    component: () => import('@/views/inventory/Production.vue'),
                    meta: { title: 'Raw Product Production - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-production',
                    name: 'Semi & Finished Product Production',
                    component: () => import('@/views/inventory/FinishedProductProduction.vue'),
                    meta: { title: 'Semi & Finished Product Production - Solution Experts' }
                },
                {
                    path: '/inventory/composition-of-materials',
                    name: 'Semi & Finished Composition Of Materials',
                    component: () => import('@/views/inventory/CompositionOfMaterials.vue'),
                    meta: { title: 'Semi & Finished Composition Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-bill-of-materials',
                    name: 'Semi & Finished Bill Of Materials',
                    component: () => import('@/views/inventory/FinishedProductBillOfMaterials.vue'),
                    meta: { title: 'Semi & Finished Bill Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/goods-receipt-note',
                    name: 'Goods Receipt Note',
                    component: () => import('@/views/inventory/GoodsReceiptNote.vue'),
                    meta: { title: 'Goods Receipt Note - Solution Experts' }
                },
                {
                    path: '/inventory/goods-receipt-return-note',
                    name: 'Goods Receipt Return Note',
                    component: () => import('@/views/inventory/GoodsReceiptReturnNote.vue'),
                    meta: { title: 'Goods Receipt Return Note - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-adjustment',
                    name: 'Raw Product Adjustment Voucher',
                    component: () => import('@/views/inventory/RawProductAdjustment.vue'),
                    meta: { title: 'Raw Product Adjustment Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/product-adjustment-value-based',
                    name: 'Semi & Finished Product Adjustment Value Based Voucher',
                    component: () => import('@/views/inventory/FinishedProductAdjustmentValueBased.vue'),
                    meta: { title: 'Finished Product Adjustment Value Based Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-adjustment-value-based',
                    name: 'Raw Product Adjustment Value Based Voucher',
                    component: () => import('@/views/inventory/RawProductAdjustmentValueBased.vue'),
                    meta: { title: 'Raw Product Adjustment Value Based Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-consumption',
                    name: 'Raw Product Consumption Voucher',
                    component: () => import('@/views/inventory/RawProductConsumption.vue'),
                    meta: { title: 'Raw Product Consumption Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-consumption-return',
                    name: 'Raw Product Consumption Return Voucher',
                    component: () => import('@/views/inventory/RawProductConsumptionReturn.vue'),
                    meta: { title: 'Raw Product Consumption Return Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-transfer',
                    name: 'Raw Product Transfer Voucher',
                    component: () => import('@/views/inventory/RawProductTransfer.vue'),
                    meta: { title: 'Raw Product Transfer Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-transfer',
                    name: 'Finished Product Transfer Voucher',
                    component: () => import('@/views/inventory/FinishedProductTransfer.vue'),
                    meta: { title: 'Finished Product Transfer Voucher - Solution Experts' }
                },
                {
                    path: '/sales/sales-order',
                    name: 'Sales Order',
                    component: () => import('@/views/sales/SalesOrder.vue'),
                    meta: { title: 'Sales Order - Solution Experts' }
                },
                {
                    path: '/inventory/delivery-challan',
                    name: 'Delivery Challan',
                    component: () => import('@/views/inventory/DeliveryChallan.vue'),
                    meta: { title: 'Delivery Challan - Solution Experts' }
                },
                {
                    path: '/sales/sales-invoice',
                    name: 'Sales Invoice',
                    component: () => import('@/views/sales/SalesInvoice.vue'),
                    meta: { title: 'Sales Invoice - Solution Experts' }
                },
                {
                    path: '/sales/sales-return',
                    name: 'Sales Return (Credit Note)',
                    component: () => import('@/views/sales/SalesReturn.vue'),
                    meta: { title: 'Sales Return (Credit Note) - Solution Experts' }
                },
                {
                    path: '/sales/sales-invoice-factory',
                    name: 'Sales Invoice Factory',
                    component: () => import('@/views/sales/SalesInvoiceFactory.vue'),
                    meta: { title: 'Sales Invoice Factory - Solution Experts' }
                },
                {
                    path: '/sales/sales-return-factory',
                    name: 'Sales Return Factory (Credit Note)',
                    component: () => import('@/views/sales/SalesReturnFactory.vue'),
                    meta: { title: 'Sales Return Factory (Credit Note)' }
                },
                {
                    path: '/inventory/delivery-challan-return',
                    name: 'Delivery Challan Return',
                    component: () => import('@/views/inventory/DeliveryChallanReturn.vue'),
                    meta: { title: 'Delivery Challan Return' }
                },
                {
                    path: '/financial/account-ledger',
                    name: 'Account Ledger',
                    component: () => import('@/views/reports/financial/AccountLedger.vue'),
                    meta: { title: 'Account Ledger - Solution Experts' }
                },
                {
                    path: '/financial/trial-balance',
                    name: 'Trial Balance',
                    component: () => import('@/views/reports/financial/TrialBalance.vue'),
                    meta: { title: 'Trial Balance - Solution Experts' }
                },
                {
                    path: '/financial/cash-bank-balance-summary',
                    name: 'Cash & Bank Balance Summary',
                    component: () => import('@/views/reports/financial/CashBankBalanceSummary.vue'),
                    meta: { title: 'Cash & Bank Balance Summary - Solution Experts' }
                },
                {
                    path: '/financial/cash-book',
                    name: 'Cash Book',
                    component: () => import('@/views/reports/financial/CashBook.vue'),
                    meta: { title: 'Cash Book - Solution Experts' }
                },
                {
                    path: '/financial/cash-flow',
                    name: 'Cash Flow',
                    component: () => import('@/views/reports/financial/CashFlow.vue'),
                    meta: { title: 'Cash Flow - Solution Experts' }
                },
                {
                    path: '/financial/letter-of-credit-balance-summary',
                    name: 'Letter Of Credit Balance Summary',
                    component: () => import('@/views/reports/financial/LetterOfCreditBalanceSummary.vue'),
                    meta: { title: 'Letter Of Credit Balance Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-ledger',
                    name: 'Customer Ledger',
                    component: () => import('@/views/reports/customer/CustomerLedger.vue'),
                    meta: { title: 'Customer Ledger - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance-summary',
                    name: 'Customer Balance Summary',
                    component: () => import('@/views/reports/customer/CustomerBalanceSummary.vue'),
                    meta: { title: 'Customer Balance Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance',
                    name: 'Customer Balance',
                    component: () => import('@/views/reports/customer/CustomerBalance.vue'),
                    meta: { title: 'Customer Balance - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance-movement-summary',
                    name: 'Customer Balance Movement Summary',
                    component: () => import('@/views/reports/customer/CustomerBalanceMovementSummary.vue'),
                    meta: { title: 'Customer Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-aging',
                    name: 'Customer Aging',
                    component: () => import('@/views/reports/customer/CustomerAging.vue'),
                    meta: { title: 'Customer Aging - Solution Experts' }
                },
                {
                    path: '/customer/customer-aging-summary',
                    name: 'Customer Aging Summary',
                    component: () => import('@/views/reports/customer/CustomerAgingSummary.vue'),
                    meta: { title: 'Customer Aging Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-ledger',
                    name: 'Supplier Ledger',
                    component: () => import('@/views/reports/supplier/SupplierLedger.vue'),
                    meta: { title: 'Supplier Ledger - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance-summary',
                    name: 'Supplier Balance Summary',
                    component: () => import('@/views/reports/supplier/SupplierBalanceSummary.vue'),
                    meta: { title: 'Supplier Balance Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance',
                    name: 'Supplier Balance',
                    component: () => import('@/views/reports/supplier/SupplierBalance.vue'),
                    meta: { title: 'Supplier Balance - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance-movement-summary',
                    name: 'Supplier Balance Movement Summary',
                    component: () => import('@/views/reports/supplier/SupplierBalanceMovementSummary.vue'),
                    meta: { title: 'Supplier Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-aging',
                    name: 'Supplier Aging',
                    component: () => import('@/views/reports/supplier/SupplierAging.vue'),
                    meta: { title: 'Supplier Aging - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-aging-summary',
                    name: 'Supplier Aging Summary',
                    component: () => import('@/views/reports/supplier/SupplierAgingSummary.vue'),
                    meta: { title: 'Supplier Aging Summary - Solution Experts' }
                },
                {
                    path: '/humanResource/employee-ledger',
                    name: 'Employee Ledger',
                    component: () => import('@/views/reports/humanResource/EmployeeLedger.vue'),
                    meta: { title: 'Employee Ledger - Solution Experts' }
                },
                {
                    path: '/humanResource/employee-balance-summary',
                    name: 'Employee Balance Summary',
                    component: () => import('@/views/reports/humanResource/EmployeeBalanceSummary.vue'),
                    meta: { title: 'Employee Balance Summary - Solution Experts' }
                },
                {
                    path: '/inventory/product-ledger',
                    name: 'Raw Product Ledger',
                    component: () => import('@/views/reports/inventory/ProductLedger.vue'),
                    meta: { title: 'Raw Product Ledger - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance',
                    name: 'Raw Product Balance',
                    component: () => import('@/views/reports/inventory/ProductBalance.vue'),
                    meta: { title: 'Raw Product Balance - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-movement-summary',
                    name: 'Raw Product Balance Movement Summary',
                    component: () => import('@/views/reports/inventory/ProductBalanceMovementSummary.vue'),
                    meta: { title: 'Raw Product Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/inventory/product-ledger-by-warehouse',
                    name: 'Raw Product Ledger By Warehouse',
                    component: () => import('@/views/reports/inventory/ProductLedgerByWarehouse.vue'),
                    meta: { title: 'Raw Product Ledger By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-by-warehouse',
                    name: 'Raw Product Balance By Warehouse',
                    component: () => import('@/views/reports/inventory/ProductBalanceByWarehouse.vue'),
                    meta: { title: 'Raw Product Balance By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-ledger',
                    name: 'Finished Product Ledger',
                    component: () => import('@/views/reports/inventory/FinishedProductLedger.vue'),
                    meta: { title: 'Finished Product Ledger - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance',
                    name: 'Finished Product Balance',
                    component: () => import('@/views/reports/inventory/FinishedProductBalance.vue'),
                    meta: { title: 'Finished Product Balance - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance-movement-summary',
                    name: 'Finished Product Balance Movement Summary',
                    component: () => import('@/views/reports/inventory/FinishedProductBalanceMovementSummary.vue'),
                    meta: { title: 'Finished Product Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-ledger-by-warehouse',
                    name: 'Finished Product Ledger By Warehouse',
                    component: () => import('@/views/reports/inventory/FinishedProductLedgerByWarehouse.vue'),
                    meta: { title: 'Finished Product Ledger By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance-by-warehouse',
                    name: 'Finished Product Balance By Warehouse',
                    component: () => import('@/views/reports/inventory/FinishedProductBalanceByWarehouse.vue'),
                    meta: { title: 'Finished Product Balance By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-bom-list',
                    name: 'Finished Product Bill of Materials List',
                    component: () => import('@/views/reports/inventory/FinishedProductBomList.vue'),
                    meta: { title: 'Finished Product Bill of Materials List - Solution Experts' }
                },
                {
                    path: '/sales/sales-order-report',
                    name: 'Sales Order Report',
                    component: () => import('@/views/reports/sales/SalesOrder.vue'),
                    meta: { title: 'Sales Order Report - Solution Experts' }
                },
                {
                    path: '/uikit/formlayout',
                    name: 'formlayout',
                    component: () => import('@/views/uikit/FormLayout.vue')
                },
                {
                    path: '/uikit/input',
                    name: 'input',
                    component: () => import('@/views/uikit/InputDoc.vue')
                },
                {
                    path: '/uikit/button',
                    name: 'button',
                    component: () => import('@/views/uikit/ButtonDoc.vue')
                },
                {
                    path: '/uikit/table',
                    name: 'table',
                    component: () => import('@/views/uikit/TableDoc.vue')
                },
                {
                    path: '/uikit/list',
                    name: 'list',
                    component: () => import('@/views/uikit/ListDoc.vue')
                },
                {
                    path: '/uikit/tree',
                    name: 'tree',
                    component: () => import('@/views/uikit/TreeDoc.vue')
                },
                {
                    path: '/uikit/panel',
                    name: 'panel',
                    component: () => import('@/views/uikit/PanelsDoc.vue')
                },

                {
                    path: '/uikit/overlay',
                    name: 'overlay',
                    component: () => import('@/views/uikit/OverlayDoc.vue')
                },
                {
                    path: '/uikit/media',
                    name: 'media',
                    component: () => import('@/views/uikit/MediaDoc.vue')
                },
                {
                    path: '/uikit/message',
                    name: 'message',
                    component: () => import('@/views/uikit/MessagesDoc.vue')
                },
                {
                    path: '/uikit/file',
                    name: 'file',
                    component: () => import('@/views/uikit/FileDoc.vue')
                },
                {
                    path: '/uikit/menu',
                    name: 'menu',
                    component: () => import('@/views/uikit/MenuDoc.vue')
                },
                {
                    path: '/uikit/charts',
                    name: 'charts',
                    component: () => import('@/views/uikit/ChartDoc.vue')
                },
                {
                    path: '/uikit/misc',
                    name: 'misc',
                    component: () => import('@/views/uikit/MiscDoc.vue')
                },
                {
                    path: '/uikit/timeline',
                    name: 'timeline',
                    component: () => import('@/views/uikit/TimelineDoc.vue')
                },
                {
                    path: '/pages/empty',
                    name: 'empty',
                    component: () => import('@/views/pages/Empty.vue')
                },
                {
                    path: '/pages/crud',
                    name: 'crud',
                    component: () => import('@/views/pages/Crud.vue')
                },
                {
                    path: '/documentation',
                    name: 'documentation',
                    component: () => import('@/views/pages/Documentation.vue')
                }
            ]
        },
        {
            path: '/landing',
            name: 'landing',
            component: () => import('@/views/pages/Landing.vue')
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },

        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        },
        { path: '/:pathMatch(.*)*', redirect: '/access' }
    ]
});

const publicPages = ['/login', '/access', '/error', '/'];

router.beforeEach((to, from, next) => {
    const authRequired = !publicPages.includes(to.path);
    const isLoggedIn = AuthService.isAuthenticated();

    if (!isLoggedIn && authRequired) {
        return next('/login');
    }

    if (to.path === '/login' && isLoggedIn) {
        return next('/');
    }

    if (!isLoggedIn && to.path === '/') {
        return next('/login');
    }

    if (authRequired) {
        const activeBranchId = JSON.parse(localStorage.getItem('activeBranchId'));
        const rawMenu = JSON.parse(localStorage.getItem('menu') || '{}');

        // Get menu items for the active branch
        const menuItems = rawMenu[activeBranchId] || [];

        const flattenLinks = (items) => {
            let links = [];
            items.forEach((item) => {
                if (item.link) {
                    links.push(item.link.startsWith('/') ? item.link : '/' + item.link);
                }
                if (item.children && item.children.length > 0) {
                    links = links.concat(flattenLinks(item.children));
                }
            });
            return links;
        };

        const allowedPaths = flattenLinks(menuItems);

        if (!allowedPaths.includes(to.path)) {
            return next('/access');
        }
    }

    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = 'Solution Experts';
    }

    next();
});

export default router;
